import { useState, useEffect } from 'react';
import Select from "react-select";
import ApiService from '../../Core/Service/ApiService';

const CategoryMultiSelect = ({ selected, onChange }) => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        ApiService.get('/categories/all').then(response => {
            setCategories(response.data.categories?.map(c => ({
                value: c.filter_desc,
                label: c.category_name
            })) || []);
        });
    }, []);

    return (
        <Select
            isMulti
            options={categories}
            value={categories.filter(c => selected.includes(c.value))}
            onChange={onChange}
        />
    );
};

export default CategoryMultiSelect;
